// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview' // 引入iview依赖
import 'iview/dist/styles/iview.css' // 引入iview css样式
import './assets/css/main.css'
import './assets/icon/iconfont.css'
import './assets/icon/iconfont2.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)
Vue.config.productionTip = false
Vue.use(iView) //使用iview组件 
Vue.use(VueAwesomeSwiper /* { default global options } */)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// router.beforeEach((to, from, next) => {
//   // ...
//   console.log('beforeEach')
//   console.log(to)
//   console.log(from)
//   next()
// })


// WEBPACK FOOTER //
// ./src/main.js